import { type ComponentProps, useState } from 'react';

import { cn } from '@/shared/utils/cn';

import { Input } from './Input';
import { EyeIcon, EyeOffIcon } from './icons';

type PasswordInputProps = Omit<ComponentProps<typeof Input>, 'type'>;

/**
 * A password field with the eye that shows what is being typed.
 *
 * The toggle is a real button after the field, out of the form's submit path and with
 * its own label, so it reads as «Mostrar la contraseña» and not as a decoration; the
 * field keeps `autoComplete` and everything else `Input` accepts. The eye sits on the
 * field's row (the label above it is 20 px plus the gap), whatever hint comes under.
 */
export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input type={visible ? 'text' : 'password'} className={cn('pr-11', className)} {...props} />
      <button
        type="button"
        aria-label={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
        aria-pressed={visible}
        onClick={() => setVisible((value) => !value)}
        className="text-ink-3 hover:text-ink focus-visible:outline-accent absolute top-6 right-0.5 inline-flex size-8 items-center justify-center rounded-md transition-colors focus-visible:outline focus-visible:outline-2"
      >
        {visible ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
      </button>
    </div>
  );
}
